import { FlowStepPhoneFrame } from "./FlowStepPhoneFrame";

type Props = {
  displayName: string;
  maskedPhone: string;
  mode?: "live" | "simulated";
  onContinue: () => void;
};

export function BuyerIdentityVerifiedStep({
  displayName,
  maskedPhone,
  mode = "live",
  onContinue
}: Props) {
  const simulated = mode === "simulated";

  return (
    <FlowStepPhoneFrame testId="buyer-identity-verified">
          <div className="flex flex-col items-center text-center">
            <div
              className={`inline-flex items-center gap-2 rounded-full px-4 py-2 text-xs font-bold uppercase tracking-wide ${
                simulated ? "bg-[#8a5a12] text-white" : "bg-[#1f6b57] text-white"
              }`}
            >
              <svg viewBox="0 0 20 20" className="h-4 w-4" fill="currentColor">
                <path
                  fillRule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clipRule="evenodd"
                />
              </svg>
              {simulated ? "Demo identity recorded" : "Identity recorded"}
            </div>

            <p className="mt-5 text-sm font-semibold text-[#191919]">{displayName}</p>
            <p className="mt-1 text-xs text-[#596158]">Device {maskedPhone}</p>

            <button
              className="button-primary mt-6 w-full"
              data-testid="buyer-identity-continue"
              type="button"
              onClick={onContinue}
            >
              View funding instructions
            </button>
          </div>
    </FlowStepPhoneFrame>
  );
}
